import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import {CONTROL_CORE_CONST} from "../config/control-core.constant";
import {CONTROL_APP_CONST} from "../../control-app/config/control-app.constant";

@Injectable()
export class SelectPaisesService {
  private _paisURL: string = `${CONTROL_APP_CONST.API_URL}paisesBoxex`;

  constructor(private http: HttpClient) { }

  getPaisesControlBox(): Observable<any> {
    return this.http.get<any>(this._paisURL);
  }
}


// WEBPACK FOOTER //
// ./src/app/control-core/services/select-paises.service.ts